// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1yY6S","productName":"Table_productName__2b24_"};